import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { PlanStockManagementPresenter } from "./presenter";
import { useYearAndMonthSelectBox } from "../../_shared";
import { useFetchPlanStock } from "../model/repository/query/use-fetch-plan-stock";

type Props = {
	hotelID: string;
};

export const PlanStockManagementContainer = ({ hotelID }: Props) => {
	const { startDt, endDt, todaysDt } = useYearAndMonthSelectBox();

	const { data: serverModel, onFetchPlanStock } = useFetchPlanStock({ hotelID, startDt, endDt });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return (
		<PlanStockManagementPresenter
			hotelID={hotelID}
			startDt={startDt}
			endDt={endDt}
			todaysDt={todaysDt}
			serverModel={serverModel}
			onFetchPlanStock={onFetchPlanStock}
		/>
	);
};

PlanStockManagementContainer.displayName = "PlanStockManagementContainer";
